<template lang="pug">
  .new-activity
    .new-activity-steps
      .new-activity-steps__title Новое мероприятие
      .new-activity-steps__content
        .new-activity-steps__steps
          .new-activity-steps__step 1
          .new-activity-steps__step.active 2
          .new-activity-steps__step 3
        .new-activity-steps__text Создайте рассадку самостоятельно: добавьте секторы и билеты.
          br
          |Или закажите создание визуальной схемы зала у нас.
    form.form.new-activity-info
      h2.h2.new-activity-info__title Добавить билеты
      .tickets-filter
        .filter.filter--right
          template(v-if="windowWidth > 767")
            .filter-item.filter-item--sector
              v-select(
                :options=['Любой', 'Сектор', 'Сектор без мест', 'Танцпол']
                :searchable="false"
                :clearable="false"
                :placeholder="'Сектор'"
                v-on="filter"
                v-model="filters.sector"
                ).form__select.form__select--filter
            .filter-item.filter-item--price
              v-select(
                :options=['Любая', '<1000', '1000 - 2000', '2000 - 3000', '3000 - 5000', '>5000',]
                :searchable="false"
                :clearable="false"
                :placeholder="'Цена'"
                v-on="filter"
                v-model="filters.price"
                ).form__select.form__select--filter
            .filter-item.filter-item--status
              v-select(
                :options=['Любой', 'Продаются', 'Заблокированы', 'Проданы']
                :searchable="false"
                :clearable="false"
                :placeholder="'Статус'"
                v-on="filter"
                v-model="filters.status"
                ).form__select.form__select--filter
          template(v-else)
            a(href="#" @click.prevent="filterMob = true").filter-mob
              svgicon(name='filter')
            .filter-mob-hidden(v-show="filterMob")
              a(href="#" @click.prevent="filterMob = false").filter-mob__back
                svgicon(name="arrow" dir="right")
                span Фильтры
              .filter-item.filter-item--sector
                v-select(
                  :options=['Любой', 'Сектор', 'Сектор без мест', 'Танцпол']
                  :searchable="false"
                  :clearable="false"
                  :placeholder="'Сектор'"
                  v-on="filter"
                  v-model="filters.sector"
                  ).form__select.form__select--filter
              .filter-item.filter-item--price
                v-select(
                  :options=['Любая', '<1000', '1000 - 2000', '2000 - 3000', '3000 - 5000', '>5000',]
                  :searchable="false"
                  :clearable="false"
                  :placeholder="'Цена'"
                  v-on="filter"
                  v-model="filters.price"
                  ).form__select.form__select--filter
              .filter-item.filter-item--status
                v-select(
                  :options=['Любой', 'Продаются', 'Заблокированы', 'Проданы']
                  :searchable="false"
                  :clearable="false"
                  :placeholder="'Статус'"
                  v-on="filter"
                  v-model="filters.status"
                  ).form__select.form__select--filter
      .tickets__content
          .activity-table
              .activity-table__title
                  .activity-table__th.at-col-1 Сектор
                  .activity-table__th.at-col-2 Мест
                  .activity-table__th.at-col-3 Цена
                  .activity-table__th.at-col-4 Сумма
                  .activity-table__th.at-col-5 Статус
                  .activity-table__th.at-col-6
              .activity-table__content
                  .activity-table__item.item-activity(
                      v-for="(sector, i) in newSectors"
                      :key="i"
                      :class="[{error: !sector.valid}]")
                      template(v-if="sector.edit")
                          .item-activity__sector.at-col-1
                              input(type="text" v-model="sector.name").item-activity__input.item-activity__input--bold
                          .item-activity__place.at-col-2
                              input(type="text" v-model="sector.place" @keyup='summChange(sector)').item-activity__input
                          .item-activity__price.at-col-3
                              input(type="text" v-model="sector.price" @keyup='summChange(sector)').item-activity__input
                          .item-activity__summ.at-col-4
                              input(type="text" v-model="sector.summ" readonly).item-activity__input
                          .item-activity__statuses.at-col-5
                              v-select(
                                  :options=['Продан', 'В продаже', 'Передано оператору', 'Пригласительный', 'Заблокирован', 'Скрыт',]
                                  :searchable="false"
                                  :clearable="false"
                                  :placeholder="'Выбрать'"
                                  v-model="sector.status"
                              ).form__select.form__select--filter
                      template(v-else)
                          .item-activity__sector.at-col-1
                              .item-activity__sector-link  {{ sector.name }}
                          .item-activity__place.at-col-2
                              .item-activity__sector  {{ sector.place }}
                          .item-activity__price.at-col-3
                              .item-activity__sector  {{ sector.price }}
                          .item-activity__summ.at-col-4
                              .item-activity__sector  {{ sector.summ }}
                          .item-activity__statuses.at-col-5
                              .item-activity__sector  {{ sector.status }}
                      .item-activity__actions.at-col-6
                          template(v-if="sector.edit")
                              a(href='#' @click.prevent="saveSector(sector)").item-activity__save-link
                                  svgicon(name='check')
                          template(v-else)
                              a(href='#' @click.prevent="editSector(sector)").item-activity__edit-link
                                  svgicon(name='edit')
                          a(href='#' @click.prevent="deleteSector(sector)").item-activity__delete-link
                              svgicon(name='delete')

                  .activity-table__item.item-activity(:class="[{error: !newSector.valid}]")
                      .item-activity__sector.at-col-1
                          input(type="text" v-model="newSector.name").item-activity__input.item-activity__input--bold
                      .item-activity__place.at-col-2
                          input(type="text" v-model="newSector.place" @keyup='summChange(newSector)').item-activity__input
                      .item-activity__price.at-col-3
                          input(type="text" v-model="newSector.price" @keyup='summChange(newSector)').item-activity__input
                      .item-activity__summ.at-col-4
                          input(type="text" v-model="newSector.summ" readonly).item-activity__input
                      .item-activity__statuses.at-col-5
                          v-select(
                              :options=['Продан', 'В продаже', 'Передано оператору', 'Пригласительный', 'Заблокирован', 'Скрыт',]
                              :searchable="false"
                              :clearable="false"
                              :placeholder="'Выбрать'"
                              v-model="newSector.status"
                          ).form__select.form__select--filter
                      .item-activity__actions.at-col-6
                          a(href='#' @click.prevent="saveSector()").item-activity__save-link
                              svgicon(name='check')
      button(
            @click.prevent="nextStep()"
        ).btn.btn--big.new-activity-info__next Далее  →  Настройки и публикация

</template>

<script>
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  name: 'NoSheme',
  data() {
    return {
      filterMob: false,
      windowWidth: null
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  methods: {
    ...mapMutations([
      'onFilters',
    ]),
    validationSector(sector) {
      let valid = false;
      for (const key in sector) {
        const arr = ['name', 'place', 'price', 'summ', 'status']
        if (arr.includes(key)) {
          valid = sector[key] !== null && sector[key] !== ''
          sector.valid = valid
          if (!valid) {
            return valid
          }
        }
      }
      return valid
    },
    summChange(sector) {
      if (sector.price && sector.place) {
        sector.summ = sector.price * sector.place
      }
    },
    saveSector(sector) {
      if (sector) {
        if (this.validationSector(sector)) {
          sector.edit = false
        }
      } else {
        if (this.validationSector(this.newSector)) {
          if(this.newSectors.length > 0) {
            let indexArr = [];
            this.newSectors.map(item => indexArr.push(item.id))
            this.newSector.id = Math.max(...indexArr) + 1;
          } else {
            this.newSector.id = 1;
          }

          const copySector = Object.assign({}, this.newSector);
          const res = this.newSectors.find(item => item.id == copySector.id);
          const index = this.newSectors.findIndex(item => item.id == copySector.id);
          if(res !== undefined) {
              this.newSectors.splice(index, 1, copySector)
          } else {
              this.newSectors.push(copySector)
          }

          this.newSector.name = null;
          this.newSector.place = null;
          this.newSector.price = null;
          this.newSector.summ = null;
          this.newSector.status = null;
          return false;
        }
      }
    },
    editSector(sector) {
      sector.edit = true
    },
    deleteSector(sector) {
      const index = this.newSectors.findIndex(item => item.id == sector.id);
      this.newSectors.splice(index, 1)
    },
    nextStep: function(){
        return this.$router.push({ name: 'setting' })
    },
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
  },
  computed: {
    ...mapGetters([
      'filters',
      'newSector',
      'newSectors',
    ]),
    filter() {
      if(event !== undefined) {
        const current = event.target.closest('.filter-item');
        if(current != null) {
          if(current.classList.contains("filter-item--sector")) {
            this.onFilters({type: 'status', amount: null});
            this.onFilters({type: 'price', amount: null});
          }
          if(current.classList.contains("filter-item--status")) {
            this.onFilters({type: 'sector', amount: null});
            this.onFilters({type: 'price', amount: null});
          }
          if(current.classList.contains("filter-item--price")) {
            this.onFilters({type: 'sector', amount: null});
            this.onFilters({type: 'status', amount: null});
          }
        }
      }
      for (let i = 0; i < this.newSectors.length; i++) {
        const sector = this.newSectors[i];
        const _sector = this.filters.sector;
        let _status = this.filters.status;
        let _price = this.filters.price;
        sector.visible = false;
        switch (_status) {
          case 'Продаются':
            _status = 'sale'
            break;
          case 'Заблокированы':
            _status = 'locked'
            break;
          case 'Проданы':
            _status = 'saled'
            break;
          case 'Любой':
            _status = 'Любой'
            break;
          default: _status = null
            break;
        }
        if (_price === 'Любая') {
          this.onFilters({type: 'price', amount: null});
          sector.visible = true;
        }
        if (_status === 'Любой') {
          this.onFilters({type: 'status', amount: null});
          sector.visible = true;
        }
        if (_sector === 'Любой') {
          this.onFilters({type: 'sector', amount: null});
          sector.visible = true;
        }
        if (_sector == null && _status == null && _price == null) {
          sector.visible = true;
        } else {
          if (_sector === sector.type) {
            sector.visible = true;
          }
          if (sector.status.includes(_status)) {
            sector.visible = true;
          }
          if(_price !== 'Любая' && _price !== null){
            if (this.filterPrice.includes(sector.id)) {
              sector.visible = true;
            }
          }
        }
      }
      return false;
    },
    filterPrice() {
      let visibleId = [];
      const min = this.priceArr[0];
      const max = this.priceArr[1];
      this.newSectors.forEach(item => {
        item.price.forEach(price => {
          if(price >= min && price <= max) {
            visibleId.push(item.id)
          }
        });
      });
      return visibleId;
    },
    priceArr() {
      let arr = [];
      const filterPrice = this.filters.price;
      if(filterPrice === '<1000') {
        arr = [0, 1000];
      } else if (filterPrice === '>5000') {
        arr = [5001, 1e7];
      } else {
        arr = filterPrice.split('-');
      }
      let priceArr = [];
      for (let price of arr) {
        priceArr.push(parseInt(price))
      }
      return priceArr;
    },
    validation(){
      let valid = false;
      let name;
      if(this.newSector.name != null && this.newSector.name.length > 3){
        name = this.newSector.name.trim();
      }
      if(!!name && !!this.newSector.type) {
        valid = true;
      } else {
        valid = false;
      }
      return valid;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  }
}
</script>

<style lang="scss">
.new-activity-steps{
  padding: 40px 40px;
  background-color: #008cff;
  background-image: linear-gradient(to right, #008cff 0%, #b533eb 100%);
  &__title{
    color: #fff;
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  &__content{
    display: flex;
  }
  &__steps{
    display: flex;
    margin-right: 35px;
  }
  &__step{
    width: 50px;
    height: 50px;
    border: 1px solid rgba(#fff, 0.5);
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 26px;
    margin-right: 20px;
    border-radius: 50%;
    &.active{
      background-color: #fff;
      border-color: #fff;
      color: #161616;
    }
  }
  &__text{
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: 25px;
  }
}
.new-activity-info{
  padding: 0px 40px;
  margin: 30px 0 40px;
  &__content{
    display: flex;
    margin-bottom: 20px;
  }
}
.tickets__add-sector-link{
  margin-right: 10px;
  display: inline-flex;
  align-items: center;
  .svg-icon{
    margin-right: 10px;
    width: 14px;
    height: 14px;
  }
}

.tickets__content{
  margin-bottom: 50px;
}

.tickets-filter{
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &__title{
    display: inline-flex;
    border-radius: 18px;
    background-color: #eee;
  }
}
.filter--right{
    margin-left: auto;
}
.activity-table{
    width: 100%;
    &__title{
        display: flex;
        margin-bottom: 10px;
        padding: 0px 25px;
    }
    &__th{
        color: #9398a2;
        font-size: 14px;
    }
    &__content{
        box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
    }
}
.item-activity{
    display: flex;
    align-items: center;
    background-color: #ffffff;
    padding: 15px 25px;
    color: #161616;
    font-size: 14px;
    position: relative;
    min-height: 45px;
    text-decoration: none;
    &.error{
      background: #fdebeb;
    }
    &:before{
        content: '';
        display: block;
        position: absolute;
        top: -1px;
        left: 25px;
        width: calc(100% - 50px);
        height: 1px;
        background: #e4e4e4;
    }
    &:first-child:before{
        display: none;
    }
    &__sector{
        display: flex;
        span{
            border: 1px solid #e4e4e4;
            background-color: #fff;
            width: 18px;
            height: 18px;
            margin-right: 20px;
            border-radius: 50%;
            color: transparent;
            display: flex;
            justify-content: center;
            align-items: center;
            .svg-icon{
                width: 12px;
                height: 12px;
                display: block;
            }
        }
        &-link {
            color: #161616;
            font-size: 16px;
            font-weight: 600;
            text-decoration: none;
            border-bottom: 1px solid transparent;
            &:hover {
                border-bottom-color: #161616;
            }
        }
    }
    &__activity{
        display: flex;
    }
    &__status{
        font-size: 14px;
        font-weight: 600;
        span{
            margin-right: 15px;
        }
        &--planning{
            color: #008cff;
        }
        &--pause{
            color: #e67c27;
        }
        &--sale{
            color: #36b067;
        }
        &--arhive{
            color: #7b7b7b;
        }
        &--cancel{
            color: #e67c27;
        }
        &--saled{
            color: #ffcc00;
        }
        &--locked{
            color: #9398a2;
        }
        &--hide{
            color: #b533eb;
        }
        &--reserve{
            color: #008cff;
        }
        .svg-icon{
            width: 25px;
            height: 25px;
        }
    }
    &__actions{
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    &__clear-link,
    &__save-link,
    &__edit-link,
    &__delete-link{
        color: #008cff;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: inline-flex;
        margin-left: 10px;
        .svg-icon{
            width: 22px;
            height: 23px;
            margin: auto;
        }
        &:hover{
            background-color: #018cff;
            color: #fff;
        }
    }
    &__clear-link{
        background-color: #ff0000;
        color: #fff;
        .svg-icon{
            width: 15px;
            height: 15px;
        }
        &:hover{
            background-color: #c90000;
        }
    }
    &__save-link{
        background-color: #78c076;
        color: #fff;
        .svg-icon{
            width: 15px;
            height: 15px;
        }
        &:hover{
            background-color: #3fa83d;
        }
    }
    &__add-place-link{
        color: #161616;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        span{
            margin-left: 10px;
            border: 2px solid #1c99ff;
            background-color: #fff;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            color: #008cff;
            display: inline-flex;
            justify-content: center;
            align-items: center;
        }
        .svg-icon{
            display: block;
            width: 12px;
            height: 12px;
        }
        &:hover{
            color: #008cff;
            span{
                background: #008cff;
                color: #fff;
            }
        }
    }
    &__input{
        height: 37px;
        border: 1px solid #e4e4e4;
        background-color: #ffffff;
        line-height: 35px;
        width: calc(100% - 20px);
        box-sizing: border-box;
        margin-right: 20px;
        padding: 0 10px;
        color: #161616;
        font-size: 16px;
        outline: none;
        &:focus{
            border-color: #9f9f9f;
        }
        &--bold{
            font-weight: 600;
        }
    }
}
.at-col-1{
    width: 20%;
}
.at-col-2{
    width: 15%;
}
.at-col-3{
    width: 15%;
}
.at-col-4{
    width: 15%;
}
.at-col-5{
    width: 15%;
    .form__select{
        width: 100%;
    }
}
.at-col-6{
    width: 20%;
}


.no-result{
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    margin: 40px 0;
}

@media (max-width: 1199px) {
  .tickets-filter__title{
    margin-bottom: 20px;
  }
  .new-activity-info .tickets-filter{
    flex-direction: column;
    align-items: flex-start;
  }
    .activity-table{
        min-width: 900px;
    }
    .item-activity__actions{
        flex-direction: row;
    }
}
@media (max-width: 991px) {
  .new-activity-info{
    padding: 0 20px;
  }
  .tickets__content{
    overflow: auto;
    padding: 0 20px 20px;
    margin-right: -20px;
    margin-left: -20px;
    margin-bottom: 30px;
  }
    .no-result{
        text-align: left;
    }
}
@media (max-width: 767px) {
  .new-activity-steps {
    padding: 20px;
  }
  .new-activity-steps__content{
    flex-direction: column;
  }
  .new-activity-steps__steps {
    margin-bottom: 20px;
    margin-right: 0;
  }
  .new-activity-steps__text {
    font-size: 14px;
    line-height: 20px;
  }
  .new-activity-info .tickets-filter{
    flex-direction: row;
    align-items: center;
    margin-right: -20px;
  }
  .tickets-filter__title{
    margin-bottom: 0px;
  }
  .activity-table__th{
    display: block;
  }
  .tickets-filter__title{
    flex-wrap: wrap;
    margin-right: 20px;
  }
  .new-activity-info__content{
      flex-direction: column;
  }
}
@media (max-width: 479px) {
  .tickets__add-sector-link{
    margin-bottom: 20px;
  }
}
</style>